import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import { articles } from '@/mocks/articles';

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.id === slug);

  if (!article) {
    return (
      <>
        <ScrollToTop />
        <Navbar />
        <Breadcrumb />
        <main className="py-20 text-center">
          <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-primary-100 flex items-center justify-center">
            <i className="ri-error-warning-line text-3xl text-primary-500"></i>
          </div>
          <h1 className="text-xl font-semibold text-foreground-800 mb-3">文章未找到</h1>
          <p className="text-foreground-500 mb-6">您访问的文章不存在或已被移除</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors duration-200"
          >
            <i className="ri-home-line"></i>
            返回首页
          </Link>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Breadcrumb />
      <main>
        <article className="py-10 md:py-14">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <header className="mb-8">
              <div className="flex items-center gap-3 flex-wrap mb-4">
                {article.tags.map((tag) => (
                  <span key={tag} className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-700 text-xs">
                    {tag}
                  </span>
                ))}
              </div>
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4 leading-snug">
                {article.title}
              </h1>
              <div className="flex items-center gap-4 text-sm text-foreground-400">
                <span>{article.author}</span>
                <span>·</span>
                <span>{article.date}</span>
                <span>·</span>
                <span>{article.readTime}阅读</span>
              </div>
            </header>

            <div className="aspect-video rounded-xl overflow-hidden mb-10">
              <img
                src={article.cover}
                alt={article.title}
                className="w-full h-full object-cover"
              />
            </div>

            <div className="prose-custom text-foreground-800 leading-relaxed">
              {article.content.split('\n').map((paragraph, i) => {
                const trimmed = paragraph.trim();
                if (!trimmed) return null;
                if (trimmed.startsWith('## ')) {
                  return (
                    <h2 key={i} className="text-xl font-semibold text-foreground-900 mt-8 mb-4">
                      {trimmed.replace('## ', '')}
                    </h2>
                  );
                }
                return (
                  <p key={i} className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                    {trimmed}
                  </p>
                );
              })}
            </div>

            <div className="mt-12 pt-8 border-t border-background-200/70">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <div>
                  <h3 className="text-sm font-semibold text-foreground-800 mb-1">标签</h3>
                  <div className="flex items-center gap-2 flex-wrap">
                    {article.tags.map((tag) => (
                      <span key={tag} className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-700 text-xs">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
                <Link
                  to="/"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-100 hover:bg-background-200 text-foreground-600 text-sm font-medium transition-colors duration-200 whitespace-nowrap"
                >
                  <i className="ri-arrow-left-line"></i>
                  返回首页
                </Link>
              </div>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}